var _defs, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVsLogoHorizontalDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ring",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C9A24B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7C5CFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22D8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E7BFA"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "none",
    stroke: "url(#ring)",
    strokeWidth: 2.4,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C9A24B",
    fill: "none",
    strokeWidth: 2.6,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 60 C 38 51, 27 51, 17 60 C 27 69, 38 69, 46 60 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 60 C 38 51, 27 51, 17 60 C 27 69, 38 69, 46 60 Z",
    transform: "rotate(-38 60 60)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 60 C 38 51, 27 51, 17 60 C 27 69, 38 69, 46 60 Z",
    transform: "rotate(38 60 60)",
    opacity: 0.85
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#22D8F0",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 60 H 98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 51 L 85 38.5 H 94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 69 L 85 81.5 H 94"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 60,
    r: 3.8,
    fill: "#22D8F0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 38.5,
    r: 3.2,
    fill: "#22D8F0",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 81.5,
    r: 3.2,
    fill: "#22D8F0",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 6.2,
    fill: "#7C5CFC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 11.4,
    fill: "none",
    stroke: "#7C5CFC",
    strokeWidth: 1.4,
    opacity: 0.45
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 152,
    y: 79,
    fontFamily: "Marcellus",
    fontSize: 46,
    letterSpacing: 2.5,
    fill: "#EBEFFB"
  }, "Vedic ", /*#__PURE__*/React.createElement("tspan", {
    fill: "url(#wg)"
  }, "Surgery"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 107,
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 13.5,
    letterSpacing: 7.5,
    fill: "#C9A24B"
  }, "SHALYA TANTRA \xB7 AI")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsLogoHorizontalDark);
export default __webpack_public_path__ + "static/media/vs-logo-horizontal-dark.3a9f892fa6e6577d1c17e0bba0eedeb5.svg";
export { ForwardRef as ReactComponent };